import {
  CmpTypographyField,
  CmpSelectField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import {
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCContent({
  sTransItemStockObj,
  xTransItemStockShow,
  vRdxWmsHead,
  xContent_Focus,
  xContent_Blur,
  xErrorMsgDetail,
  xKey,
  xBufferObj,
  sUnit,
  fUnit,
  fItemName,
  fOpenContentItemSearchModalKey,
  fQty,
  fQtyEnter,
  fPacking,
  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
}) {
  return (
    <form className="Wms-inbound-grn-content" id="WmsLoadingReceiptContent">
      <Grid container spacing={0.9} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
          textAlign={"end"}
          justifyContent={"end"}
        >
          <Grid item xs={"auto"} sm={"auto"} md={"auto"}>
            <div className="d-flex justify-content-between">
              
              <span
                className={
                  vRdxWmsHead.A_DocStat == "POST"
                    ? "hide-all-time"
                    : "d-flex justify-content-between align-items-center"
                }
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Stock=" + sTransItemStockObj.RPStock}
                />{" "}
                &nbsp; &nbsp;
                {xTransItemStockShow ? (
                  <>
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={" CostPr=" + sTransItemStockObj.CostPr}
                    />
                    &nbsp;&nbsp;
                    <CmpTypographyField
                      xcomponent={"span"}
                      xText={"LPRate=" + sTransItemStockObj.LPRate}
                    />{" "}
                  </>
                ) : (
                  <></>
                )}
                &nbsp; &nbsp;
              </span>
            </div>
          </Grid>
        </Grid>
        {/* {!xMediaQuery && (
          <Grid item xs={12} sm={2} md={1} className="lastkeyDetect">
            <CmpTextFieldV1
              xLabelText="S.No"
              xSize="small"
              xValue={xBufferObj.B_Srno}
              xType={"text"} // text/number/password
              xName={"B_Srno"}
              xReadOnly={true}
              xOnChange={""}
              xError={xErrorMsgDetail.B_Srno === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_Srno}
              // xOnKeyUp={xKey}
            />
          </Grid>
        )} */}
        <Grid item xs={12} sm={2} md={2} lg={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Item Code"
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Itmcd}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={12}
          // sm={"auto"}
          // md={"auto"}
          // lg={"auto"}
          sm={8}
          md={xToggle ? 7.5:5}
          // lg={5}

          className="lastkeyDetect"
        >
          <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"101"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={xBufferObj?.B_ItmName}
            xReadOnly={false}
            xOnChange={fItemName}
            xOnKeyUp={fOpenContentItemSearchModalKey}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xonClickbtn}
            xrows={xrows}
            xcolumns={xcolumns} //head
            xRowCellClick={xRowCellClick}
            xRowClick={xRowClick}
            xToggle={xToggle}
            xData={xData}
            xOnChangeDropdownInput={xOnChangeDropdownInput}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Qty"
            xSize="small"
            xtabIndex={"102"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Qty}
            xOnKeyUp={(e) => {
              fQtyEnter(e);
            }}
            xonFocus={(e) => {
              xContent_Focus(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1.5} className="lastkeyDetect">
          <CmpSelectFieldV1
            xSize="small"
            xtabIndex={"103"}
            xLabelText="Unit"
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"B_Unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Unit}
            xDisable={false}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1} className={"lastkeyDetect"}>
           
          <CmpTextFieldV1
            xLabelText="Packing"
            xValue={xBufferObj.Packing}
            xSize="small"
            xType={"text"} // text/number/password
            xName={"Packing"}
            xReadOnly={true}
            xOnChange={fPacking}
            xError={xErrorMsgDetail.Packing === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.Packing}
            xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1} className={"lastkeyDetect"}>
        
          <CmpTextFieldV1
            xLabelText="BaseQty"
            xValue={xBufferObj.B_BaseQty}
            xSize="small"
            xType={"text"} // text/number/password
            xName={"B_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
      </Grid>
    </form>
  );
}
